import React from 'react'

import './Panels.css'

export type Props = {
  children: React.ReactNode
}

function PanelHeader(props: Props) {
  return (
    <div className="panel-header">
      {props.children}
    </div>
  )
}

export default PanelHeader
